import React, { useEffect } from 'react';
import { TextField } from '@mui/material';
import { Formik } from 'formik';
import { useIntl } from 'react-intl';
import { ButtonWithLoader } from '../../../components/other/Buttons';
import { useStylesBonusesUser } from '../users/users/hooks/useStyles';
import { useAddLimitsOperators } from './hooks/useAddLimitsOperators';
import { setLayoutFooter, setLayoutSubheader } from '../../../utils/layout';
import { useGetLimitsOperators } from './hooks/useGetLimitsOperators';
import Preloader from '../../../components/ui/Preloader/Preloader';

const OperatorsLimitsPage: React.FC = () => {
  const classes = useStylesBonusesUser();
  const intl = useIntl();
  const [fetch, loading] = useAddLimitsOperators()
  const [getLimits, limits, getLoading] = useGetLimitsOperators()

  setLayoutSubheader({
    title: 'Лимиты для кассиров',
  });
  setLayoutFooter({ show: true });

  useEffect (() => {
    getLimits()
  }, [])

  if(getLoading){
    return <Preloader />
  }

  return (
    <div className={classes.container}>
      <Formik
        initialValues={{
          limit_per_day: limits?.cashier_limits_per_day || '',
          limit_for_taxi_driver: limits?.cashier_limits_for_taxi_driver || '',
        }}
        onSubmit={values => {
          fetch({
            limit_per_day: values.limit_per_day, 
            limit_for_taxi_driver: values.limit_for_taxi_driver
          });
        }}
        >
        {({ values, errors, touched, handleBlur, handleSubmit, setFieldValue }) => (
          <form className={classes.form} onSubmit={handleSubmit}>
            <TextField
                type='text'
                label='Ограничение по кассиру'
                margin='normal'
                name='limit_per_day'
                value={values.limit_per_day || ''}
                variant='outlined'
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue('limit_per_day', e.target.value);
                }}
                helperText={
                  touched.limit_per_day && typeof errors.limit_per_day === 'string'
                    ? errors.limit_per_day
                    : ''
                }
                error={Boolean(touched.limit_per_day && errors.limit_per_day)}
            />

            <TextField
              type='text'
              label='Ограничение по водителя'
              margin='normal'
              name='limit_for_taxi_driver'
              value={values.limit_for_taxi_driver || ''}
              variant='outlined'
              onBlur={handleBlur}
              onChange={e => {
                setFieldValue('limit_for_taxi_driver', e.target.value);
              }}
              helperText={
                touched.limit_for_taxi_driver && typeof errors.limit_for_taxi_driver === 'string'
                  ? errors.limit_for_taxi_driver
                  : ''
              }
              error={Boolean(touched.limit_for_taxi_driver && errors.limit_for_taxi_driver)}
            />

            <div className={classes.actions}>
              <ButtonWithLoader
                disabled={!values.limit_for_taxi_driver || !values.limit_per_day}
                loading={loading}
                type='submit'
              >
              {intl.formatMessage({ id: 'USER.BUTTON.ADD' })}
              </ButtonWithLoader>
            </div>
          </form>
        )}
        </Formik>
    </div>
  );
};

export default React.memo(OperatorsLimitsPage);
